import styled from '@emotion/styled';

import { MobileNavBoxItem, NavBoxItem } from '../../../components/Link/Link';
import { settingNavConfig } from './navConfig';

const SettingNavBoxItem = () => {
  return (
    <ContainerWrapper>
      <NavBtnSectionWeb>
        {settingNavConfig.map((nav) => {
          return (
            <NavBoxItem
              path={nav.path}
              key={nav.title}
              icon={nav.icon}
              className='active-grey'
            >
              {nav.title}
            </NavBoxItem>
          );
        })}
      </NavBtnSectionWeb>

      <NavBtnSectionMobile>
        {settingNavConfig.map((nav) => {
          return (
            <MobileNavBoxItem
              path={nav.path}
              key={nav.title}
              icon={nav.icon}
              className='active-grey'
            >
              {nav.title}
            </MobileNavBoxItem>
          );
        })}
      </NavBtnSectionMobile>
    </ContainerWrapper>
  );
};

export default SettingNavBoxItem;

const ContainerWrapper = styled.div`
  width: 258px;
  transition: width 0.3s ease-in-out;
  border-right: 1px solid ${({ theme }) => theme.palette.borderColor};
  min-height: 80vh;

  &.closed-nav {
    width: 0px;
  }

  @media (max-width: 884px) {
    width: 100%;
    min-height: fit-content;
    border-right: 0px;
  }
`;

const NavBtnSectionWeb = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 884px) {
    display: none;
  }
`;

const NavBtnSectionMobile = styled.section`
  display: none;

  @media (max-width: 884px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
